module.exports = __webpack_public_path__ + "static/img/cqqlogo.0e3d255.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cqqlogo.png
// module id = a9RW
// module chunks = 1